import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import { PortfolioOverviewPanel } from './PortfolioOverviewPanel';
import { SharedPatternsPanel } from './SharedPatternsPanel';
import { CategoryBreakdownPanel } from './CategoryBreakdownPanel';
import { PhaseDistributionPanel } from './PhaseDistributionPanel';
import { IntelExplorerLaunchPanel } from './IntelExplorerLaunchPanel';
import { IntelMethodologyPanel } from './IntelMethodologyPanel';

/**
 * Intel sidebar for cross-project intelligence synthesis
 * Renders only when pathname.startsWith('/intelligence')
 * Provides operator context:
 * - Portfolio overview (total projects, patterns, most active)
 * - Shared patterns across projects
 * - Category distribution across portfolio
 * - Projects grouped by lifecycle phase
 * - Quick-launch 3D Fibonacci sphere explorer
 * - Intel methodology reference
 */
export function IntelSidebar(): React.ReactElement {
  return (
    <aside className="w-60 border-r border-border bg-surface">
      <ScrollArea className="h-full">
        <div className="flex flex-col gap-0">
          {/* Portfolio Overview */}
          <div className="px-4 py-3">
            <PortfolioOverviewPanel />
          </div>
          <Separator />

          {/* Shared Patterns */}
          <div className="px-4 py-3">
            <SharedPatternsPanel />
          </div>
          <Separator />

          {/* Category Breakdown */}
          <div className="px-4 py-3">
            <CategoryBreakdownPanel />
          </div>
          <Separator />

          {/* Phase Distribution */}
          <div className="flex flex-1 flex-col px-4 py-3">
            <PhaseDistributionPanel />
          </div>
          <Separator />

          {/* Explorer Launch */}
          <div className="px-4 py-3">
            <IntelExplorerLaunchPanel />
          </div>
          <Separator />

          {/* Methodology Reference */}
          <div className="px-4 py-3">
            <IntelMethodologyPanel />
          </div>

          {/* Bottom padding */}
          <div className="h-4" />
        </div>
      </ScrollArea>
    </aside>
  );
}
